import { render, staticRenderFns } from "./EmployeePermissionHolder.vue?vue&type=template&id=273c4208&scoped=true&"
import script from "./EmployeePermissionHolder.vue?vue&type=script&lang=ts&"
export * from "./EmployeePermissionHolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c4208",
  null
  
)

export default component.exports